import { COUNTRY, LANGUAGE } from "@type/index";

// For GU, should show kids & baby
// export const isGuKids = (brand: string, genderCode: number): Array<number> =>
//   isGu(brand) && genderCode === 3 ? [3, 4] : [genderCode];

export const isMultiLangCountry = (country: COUNTRY): boolean =>
  [COUNTRY.CA, COUNTRY.ID, COUNTRY.TH, COUNTRY.VN].includes(country);

export const isCAFR = (region: string, language: string) =>
  region === COUNTRY.CA && language === LANGUAGE.FR;
